import { Box2, Vector2, Vector2Tuple } from "three";

export class PixelSpace
{
  #min:Vector2 = new Vector2( 0, 0 );
  #max:Vector2 = new Vector2( 0, 1 );

  #transformer:Vector2 = new Vector2( 1, 1 );
  #size:Vector2 = new Vector2( 1, 1 );

  #thinLinesOffset = new Vector2( 0.5, 0.5 );
  compute( x:number, y:number, out:Vector2 )
  {
    out.set( x, y );
    out.sub( this.#min );
    out.multiply( this.#transformer );
    out.round();
    out.add( this.#thinLinesOffset );
  } 

  #containsBox = new Box2();
  #spaceBox = new Box2();

  intersects( min:Vector2, max:Vector2 )
  {
    this.#containsBox.min = min;
    this.#containsBox.max = max;
    
    return this.#spaceBox.intersectsBox( this.#containsBox ); 
  }

  set( min:Vector2, max:Vector2, size:Vector2 )
  {
    this.#min.copy( min );
    this.#max.copy( max );
    this.#size.copy( size );

    this.#spaceBox.min = this.#min;
    this.#spaceBox.max = this.#max;

    this.#computeTransformer();
  }

  setRange( min:Vector2, max:Vector2 )
  {
    this.#min.copy( min );
    this.#max.copy( max );

    this.#computeTransformer();
  }

  setSize( size:Vector2 )
  {
    this.#size.copy( size );
    this.#computeTransformer();
  }

  #computeTransformer()
  {
    let range  = this.#max.clone().sub( this.#min );
    range.x = this.#size.x / range.x;
    range.y = this.#size.y / range.y;

    this.#transformer.copy( range );
  }

}